import {get} from '@servicenow/ui-internal';

export default function isSubscription(document = {}) {
	const operation = get(document, 'definitions[0].operation');
	return operation && operation === 'subscription';
}
